<script lang="ts">
    import Btn from "../../components/Btn.svelte";
    import Container from "../../components/Container.svelte";
    import Divider from "../../components/Divider.svelte";
    import Dropdown from "../../components/Dropdown.svelte";
    import Gap from "../../components/Gap.svelte";
    import Headline from "../../components/Headline.svelte";
    import Hero from "../../components/Hero.svelte";
    import Image from "../../components/Image.svelte";
    import LightTheme from "../../components/LightTheme.svelte";
    import Subline from "../../components/Subline.svelte";
    import ProjectPreviews from "../../components/ProjectPreviews.svelte";
    import PagePreviews from "../../components/PagePreviews.svelte";
    import type { ProjectPreview } from "../../components/ProjectPreviews.svelte";
    import type { Project } from "../../components/ProjectPreviews.svelte";
    import { ProjectCateories } from "../../components/ProjectPreviews.svelte";
    import { t } from "../../helpers/translation";

    const loadData = async (): Promise<Project[]> => {
        const data: Project[] = await fetch("/api/projects")
            .then((data) => data.json())
            .then((data) => {
                data.forEach((event) => {
                    if (event.startdate && event.enddate)
                        event.date =
                            new Date(event.startdate).toLocaleDateString() +
                            " - " +
                            new Date(event.enddate).toLocaleDateString();
                    else if (event.startdate)
                        event.date = new Date(
                            event.startdate,
                        ).toLocaleDateString();
                    else if (event.enddate)
                        event.date = new Date(
                            event.enddate,
                        ).toLocaleDateString();
                    else event.date = "";
                });
                data = data.filter(
                    (proj) =>
                        proj.projectcategoryid == ProjectCateories.WACHEN_ELW,
                );
                return data;
            });

        return data ? Promise.resolve<Project[]>(data) : Promise.reject(null);
    };
</script>

<LightTheme />

<Hero
    headline={$t("page.wachenelw.hero.headline")}
    small
    vid="https://liveicom.azureedge.net/sinus/vid/sinus_wachen_elw.mp4"
/>

<Container big>
    <Headline>
        {@html $t("page.wachenelw.headline")}
    </Headline>
    <Subline>
        {@html $t("page.wachenelw.subline")}
    </Subline>

    <Gap height="6rem" />

    <div class="grid">
        <div class="div">
            <Image
                src="https://liveicom.azureedge.net/sinus/img/AdobeStock_189229591.jpg"
                alt="wache einsatz"
                rounded
                height="100%"
            />
            <Gap height="2rem" />
        </div>

        <div>
            <p>
                {@html $t("page.wachenelw.p.1")}
            </p>
            <p>
                {@html $t("page.wachenelw.p.2")}
            </p>
            <p>
                {@html $t("page.wachenelw.p.3")}
            </p>
            <p>
                {@html $t("page.wachenelw.p.4")}
            </p>
            <!-- <Btn href="kontakt" arrow>
                {@html $t("page.wachenelw.btn.kontakt")}
            </Btn> -->
        </div>
    </div>

    <Gap height="1rem" />

    <Dropdown
        heading={$t("page.wachenelw.dropdown.infomaterial")}
        justify_heading="left"
        auto_open
    >
        <Btn
            pdf
            small
            href="https://liveicom.azureedge.net/sinus/files/IHM-Flyer-v8web.pdf"
            >IHM Flyer</Btn
        >
        <Btn pdf small href={$t("file.pdf.mecc.info")}>
            {@html $t("file.pdf.mecc.info.name")}
        </Btn>
        <Btn
            pdf
            small
            href="https://liveicom.azureedge.net/sinus/files/IHM-Status-Panel-sw-grafik.pdf"
            >IHM Status Panel Broschüre</Btn
        >
        <Btn
            pdf
            small
            href="https://liveicom.azureedge.net/sinus/files/Digitalfunk-BOS_print_neu.pdf"
            >Digitalfunk BOS Broschüre</Btn
        >
        <Btn
            pdf
            small
            href="https://liveicom.azureedge.net/sinus/files/SEB_PD-PMRE-VoIP-Fire-Systembeschreibung.pdf"
            >SEB VoIP-Fire-Systembeschreibung</Btn
        >
        <Btn
            pdf
            small
            href="https://liveicom.azureedge.net/sinus/files/SEB_PD-PMRE-Funkbesprechungsplatz-VBP4410_4410P.pdf"
            >SEB Funkbesprechungsplatz VBP4410</Btn
        >
        <Btn
            pdf
            small
            href="https://liveicom.azureedge.net/sinus/files/SEB_PD-PMRE-Funkbesprechungsplatz-VBP3510_3510P.pdf"
            >SEB Funkbesprechungsplatz VBP3510</Btn
        >
        <Btn
            pdf
            small
            href="https://liveicom.azureedge.net/sinus/files/SEB_PD-PMRE-Touch-FuBe.pdf"
            >SEB Touch-FuBe (Funkbesprechungsplatz)</Btn
        >
        <Btn
            pdf
            small
            href="https://liveicom.azureedge.net/sinus/files/SEB_PD-PMRE-SEB-Remote-Interface.pdf"
            >SEB Remote-Interface</Btn
        >
        <Btn
            pdf
            small
            href="https://liveicom.azureedge.net/sinus/files/SEB_PD-PMRE-Funkbedienplatz-Doppel-DIN.pdf"
            >SEB Funkbedienplatz Doppel-DIN</Btn
        >
    </Dropdown>

    <Gap height="4rem" />
    <ProjectPreviews
        data_callback={loadData}
        url_base="projekte"
        show_empty_message={false}
    />

    <Gap height="8rem" />
</Container>

<Container big>
    <PagePreviews leitstellen einsatznavigation sprach_datenfunk />
</Container>

<!-- <center>
    <Btn arrow href="kontakt">
        {@html $t("page.wachenelw.btn.projectrequest")}
    </Btn>
</center> -->

<style lang="scss">
    @import "../../vars";

    .grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 2em;
        @media (max-width: 1000px) {
            grid-template-columns: 1fr;
        }
    }
</style>
